import { useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { Button } from "@/shared/ui";
import { SKIN_KEYS } from "@/domains/createCharacter/constants/headOverlay";
import { nextStep, prevStep, setCorrectStep } from "@/domains/createCharacter/slice";
import useChangeHeadOverlay from "@/domains/createCharacter/hooks/useChangeHeadOverlay";
import CreateCharacterSetContainer from "@/domains/createCharacter/containers/CreateCharacterSetContainer";
import CreateCharacterScrollArea from "@/domains/createCharacter/components/CreateCharacterScrollArea";
import CreateCharacterStepHeader from "@/domains/createCharacter/components/CreateCharacterStepHeader";

export default function CreateCharacterHeadOverlayContainer() {
  const dispatch = useAppDispatch();
  const { randomizeAll, onChange } = useChangeHeadOverlay();

  useEffect(() => {
    dispatch(setCorrectStep({ step: 4, isCorrect: true }));
  }, [dispatch]);

  return (
    <>
      <CreateCharacterStepHeader title="Кожа" onRandom={randomizeAll} />
      <CreateCharacterScrollArea>
        {SKIN_KEYS.map((feature) => (
          <CreateCharacterSetContainer key={feature} feature={feature} onChange={onChange} />
        ))}
      </CreateCharacterScrollArea>
      <div className="grid grid-cols-2 items-center gap-2.5 pt-2 mt-auto">
        <Button variant="solid-surface-gradient" onClick={() => dispatch(prevStep())}>
          Назад
        </Button>
        <Button onClick={() => dispatch(nextStep())}>Далее</Button>
      </div>
    </>
  );
}
